export const SOLUTIONS_DATA = [
    {
        slug: "developpement-international",
        num: "01",
        title: "Développement international",
        tagline: "De la stratégie à l'exécution terrain.",
        seoTitle: "Stratégie export & développement international | WEYB",
        seoDescription:
            "WEYB accompagne les PME dans leur stratégie export : diagnostic, choix des marchés, études, prospection B2B, salons, missions commerciales et pilotage.",
        h1Title: "Stratégie export",
        heroTagline: "de la décision à l'exécution internationale",
        heroDesc:
            "WEYB accompagne votre croissance à l'international sur l'ensemble du parcours : diagnostic, stratégie, études, prospection, salons, closing et pilotage.",
        heroIntro:
            "WEYB accompagne les PME et équipes export dans la définition et l'exécution de leur stratégie export : diagnostic, choix des marchés prioritaires, études, prospection B2B, salons, missions commerciales et pilotage.",
        image: "/assets/terrain-b2b-roseblanche.jpg",
        imageAspect: "aspect-[3/4]",
        imageAlt: "Rencontre B2B lors d'un salon international — mission WEYB",
        problematique:
            "Se développer à l'international ne s'improvise pas. Choix des marchés, compréhension des usages locaux, identification des bons partenaires, présence terrain : sans méthode ni accompagnement, les initiatives export se dispersent et consomment des ressources sans produire de résultats durables.",
        pourQui: [
            "Dirigeants de PME et de startups",
            "Responsables export et commerciaux",
            "Entreprises primo-exportatrices",
            "Exportateurs souhaitant accélérer",
            "Organisations d'appui au secteur privé",
            "Institutions et programmes internationaux",
        ],
        actions: [
            { title: "Diagnostic export", desc: "Évaluation complète de votre potentiel, de vos capacités et de votre maturité internationale." },
            { title: "Stratégie export", desc: "Définition des objectifs, du positionnement et de la feuille de route internationale." },
            { title: "Priorisation des marchés", desc: "Hiérarchisation des marchés cibles selon leur potentiel réel pour votre offre." },
            { title: "Études de marché", desc: "Études, veille et analyse concurrentielle pour décider sur des bases factuelles.", href: "/expertises/etudes-de-marche" },
            { title: "Prospection B2B", desc: "Identification et qualification de partenaires, distributeurs et clients cibles.", href: "/expertises/prospection-b2b-closing" },
            { title: "Closing commercial", desc: "Accompagnement jusqu'à la signature : négociation, suivi, sécurisation des accords." },
            { title: "Salons internationaux", desc: "Préparation, ciblage des rendez-vous et exploitation concrète de vos participations.", href: "/expertises/salons-internationaux" },
            { title: "Missions B2B", desc: "Organisation et accompagnement de missions commerciales sur vos marchés cibles.", href: "/expertises/missions-b2b" },
            { title: "Accompagnement terrain", desc: "Présence opérationnelle à vos côtés, sur le terrain, quand cela compte." },
            { title: "Suivi & pilotage", desc: "Indicateurs, pipeline et pilotage continu de votre développement export." },
        ],
        livrables: [
            "Diagnostic export documenté",
            "Feuille de route avec marchés prioritaires",
            "Études et analyses de marché",
            "Pipeline de prospects et partenaires qualifiés",
            "Plan d'actions salons & missions",
            "Tableaux de pilotage export",
        ],
        faq: [
            {
                q: "Pour quelles entreprises ce pôle est-il conçu ?",
                a: "Pour les PME et startups, qu'elles soient primo-exportatrices ou déjà exportatrices et souhaitant accélérer, ainsi que pour les organisations d'appui au secteur privé, institutions et programmes internationaux.",
            },
            {
                q: "Dans quelles zones géographiques intervenez-vous ?",
                a: "WEYB intervient principalement en Europe, en Afrique et dans la zone MENA, depuis sa base en France, sa filiale en Tunisie et un réseau de partenaires et experts internationaux.",
            },
            {
                q: "Quelle différence avec une agence de prospection ?",
                a: "WEYB n'est ni une agence marketing, ni une simple société de prospection : nous accompagnons le parcours complet, de la stratégie à l'exécution terrain, avec la technologie Export360 et un accompagnement humain.",
            },
            {
                q: "Comment démarrer un accompagnement ?",
                a: "Par un premier échange de 30 minutes avec Saber Bellaaj, sans engagement, pour faire le point sur vos ambitions, vos marchés cibles et les premières actions à lancer.",
            },
        ],
    },
    {
        slug: "programmes-appui-formation",
        num: "02",
        title: "Programmes d'appui & Capacity Building",
        tagline: "Concevoir, former, accompagner, mettre en œuvre, mesurer.",
        heroDesc:
            "WEYB conçoit et met en œuvre des programmes d'appui à l'internationalisation pour les structures d'appui, institutions et partenaires du développement : ingénierie, ToT, formation, coaching, M&E.",
    },
    {
        slug: "export360",
        num: "03",
        title: "Export360",
        tagline: "La plateforme qui structure et pilote votre développement export.",
        heroDesc:
            "Développée par WEYB, Export360 centralise diagnostics, priorisation marchés, études assistées par IA, e-learning et pilotage de vos opérations internationales.",
        dark: true,
        image: "/assets/export360-screenshot.webp",
        imageAspect: "aspect-[16/10]",
        imageAlt: "La plateforme Export360 — système de pilotage export",
        externalCta: { label: "Découvrir Export360.fr", href: "https://export360.fr/" },
        problematique:
            "Dans beaucoup d'entreprises, le développement export est éclaté entre tableurs, notes et e-mails : impossible de piloter, de former les équipes ou de capitaliser sur les études. Export360 a été conçue pour rassembler tout cela dans un seul espace.",
        pourQui: [
            "Dirigeants et responsables export",
            "Équipes commerciales à structurer",
            "Entreprises primo-exportatrices",
            "Structures accompagnant des entreprises",
        ],
        actions: [
            { title: "Diagnostics", desc: "Évaluez votre maturité export et identifiez vos priorités de progression." },
            { title: "Priorisation marchés", desc: "Comparez et hiérarchisez vos marchés cibles avec des outils dédiés." },
            { title: "Outils de pilotage", desc: "Suivez vos actions, votre pipeline et vos indicateurs export au même endroit." },
            { title: "Études assistées par IA", desc: "Accélérez vos études de marché grâce à l'intelligence artificielle." },
            { title: "Salons & missions", desc: "Préparez vos événements internationaux : objectifs, rendez-vous, suivi." },
            { title: "Templates", desc: "Documents et trames prêts à l'emploi pour structurer vos démarches." },
            { title: "E-learning & quiz", desc: "Formez vos équipes au commerce international, avec quiz et leaderboard." },
            { title: "Chatbot IA", desc: "Un assistant pour répondre à vos questions export au quotidien." },
            { title: "Marketplace d'études", desc: "Accédez à des études de marché et ressources spécialisées." },
            { title: "Coachs & consultants", desc: "Accédez à des experts pour compléter la plateforme par de l'humain." },
            { title: "Opportunités business", desc: "Repérez et suivez des opportunités commerciales concrètes." },
        ],
        livrables: [
            "Un espace de pilotage export structuré",
            "Diagnostics et plans de marché prioritaires",
            "Parcours de formation pour vos équipes",
            "Préparation cadrée de vos salons et missions",
        ],
        faq: [
            {
                q: "Quelle est la différence entre WEYB et Export360 ?",
                a: "WEYB est le cabinet d'accompagnement humain ; Export360 est la plateforme technologique développée par WEYB pour structurer et piloter le développement export. Les deux sont complémentaires mais distincts.",
            },
            {
                q: "Peut-on utiliser Export360 sans accompagnement WEYB ?",
                a: "Oui, la plateforme fonctionne de manière autonome. Elle donne en plus accès à des coachs et consultants lorsque vous souhaitez un appui humain.",
            },
            {
                q: "Pour qui la plateforme est-elle pensée ?",
                a: "Pour les dirigeants, responsables export et équipes commerciales qui veulent structurer leur démarche, ainsi que pour les structures qui accompagnent des entreprises à l'international.",
            },
            {
                q: "Comment découvrir la plateforme ?",
                a: "Rendez-vous sur export360.fr pour découvrir la plateforme, ou réservez un échange de 30 minutes pour une présentation adaptée à votre situation.",
            },
        ],
    },
    {
        slug: "implantation-rh-international",
        num: "04",
        title: "Implantation & RH international",
        tagline: "Votre présence locale, sans friction.",
        heroDesc:
            "Création de structure, recrutement, portage salarial et support opérationnel : WEYB vous aide à vous implanter durablement sur vos marchés cibles.",
        problematique:
            "S'implanter sur un nouveau marché va bien au-delà du commercial : structure juridique, recrutement local, gestion administrative et comptable, organisation d'équipes… Autant de sujets critiques qui, mal anticipés, freinent ou fragilisent votre développement.",
        pourQui: [
            "Entreprises souhaitant s'implanter sur de nouveaux marchés",
            "PME sans service RH international dédié",
            "Exportateurs passant de la vente à la présence locale",
            "Dirigeants cherchant un support opérationnel fiable",
        ],
        actions: [
            { title: "Implantation internationale", desc: "Stratégie et exécution de votre installation sur un nouveau marché." },
            { title: "Création de structure", desc: "Mise en place de la structure juridique et opérationnelle adaptée." },
            { title: "Recrutement", desc: "Identification et recrutement des talents locaux dont vous avez besoin." },
            { title: "Portage salarial", desc: "Employez localement sans créer immédiatement de structure juridique." },
            { title: "Mise en place d'équipes", desc: "Constitution et montée en compétence de vos équipes locales." },
            { title: "Support administratif", desc: "Gestion des obligations administratives de votre présence locale." },
            { title: "Comptabilité", desc: "Tenue et suivi comptable adaptés au pays d'implantation." },
            { title: "Facility management", desc: "Gestion des locaux et des services généraux de votre implantation." },
            { title: "Accompagnement opérationnel", desc: "Un appui continu pour sécuriser votre quotidien sur place." },
        ],
        livrables: [
            "Une structure opérationnelle conforme",
            "Vos premiers talents recrutés",
            "Une gestion administrative et comptable externalisée",
            "Un interlocuteur unique pour votre implantation",
        ],
        faq: [
            {
                q: "Qu'est-ce que le portage salarial international ?",
                a: "Le portage salarial vous permet d'employer un collaborateur sur un marché étranger sans y créer immédiatement de structure juridique : une solution souple pour tester un marché ou démarrer rapidement.",
            },
            {
                q: "Dans quelles zones proposez-vous ces services ?",
                a: "WEYB s'appuie sur sa base en France, sa filiale en Tunisie et son réseau de partenaires internationaux, avec une expérience prioritaire en Europe, en Afrique et dans la zone MENA.",
            },
            {
                q: "Peut-on combiner implantation et développement commercial ?",
                a: "Oui, c'est même recommandé : l'implantation locale prolonge naturellement un développement commercial réussi. Les pôles de WEYB travaillent ensemble sur l'ensemble du parcours.",
            },
            {
                q: "Par où commencer ?",
                a: "Par un échange de 30 minutes avec Saber Bellaaj pour évaluer votre projet d'implantation, vos contraintes et le calendrier réaliste.",
            },
        ],
    },
];
